module.exports = __webpack_public_path__ + "img/01.53423c93.jpg";